import { PAGOS } from '../actions/types';

const initialState = {
    listado: [],
    informacion: null
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case PAGOS.BUSCAR:
            return { ...state, listado: payload };

        case PAGOS.INFORMACION:
            return { ...state, informacion: payload };

        case PAGOS.LIMPIAR:
            return { ...state, informacion: null };

        default:
            return state;
    }
};
